import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|System Activity|Logins|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.CandidateAccess,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateSystemActivityLogins';
export type SPCandidateSystemActivityLoginsLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}LabelCreated`
	| `${LocNameStart}LabelIpAddress`;

export const spCandidateSystemActivityLoginsLocs: LocDefs<SPCandidateSystemActivityLoginsLocNames> =
	{
		SPCandidateSystemActivityLoginsTitlePage: {
			defaultValue: 'Candidate Login Activity',
			description: 'Page Title',
			displayPath: `${pathStart}Page Title`,
			displayType: 'Title',
			legacyName: 'CandidateAccess/Candidates.LoginActivity.Title.PageTitle',
			...sharedProperties,
		},
		SPCandidateSystemActivityLoginsTitleTab: {
			defaultValue: 'Candidate Login Activity',
			description: 'Tab Title',
			displayPath: `${pathStart}Tab Title`,
			displayType: 'Title',
			legacyName: 'CandidateAccess/Candidates.LoginActivity.Title.TabTitle',
			...sharedProperties,
		},
		SPCandidateSystemActivityLoginsLabelCreated: {
			defaultValue: 'Created',
			description: 'Label for: Created.',
			displayPath: `${pathStart}Created`,
			displayType: 'Label',
			legacyName: 'CandidateAccess/Candidates.LoginActivity.ColumnHeading.Created',
			...sharedProperties,
		},
		SPCandidateSystemActivityLoginsLabelIpAddress: {
			defaultValue: 'IP Address',
			description: 'Label for: IP Address.',
			displayPath: `${pathStart}IP Address`,
			displayType: 'Label',
			legacyName: 'CandidateAccess/Candidates.LoginActivity.ColumnHeading.IpAddress',
			...sharedProperties,
		},
	};

export type SPCandidateSystemActivityLoginsLocType =
	LocMap<SPCandidateSystemActivityLoginsLocNames>;
